
import React from 'react';
import { UserProfile } from '../types';

interface UserCardModalProps {
  user: UserProfile;
  onClose: () => void;
  onInvite: (user: UserProfile) => void;
}

export const UserCardModal: React.FC<UserCardModalProps> = ({ user, onClose, onInvite }) => {
  return (
    <div className="bg-white rounded-[4rem] shadow-2xl max-w-5xl w-full flex flex-col md:flex-row overflow-hidden animate-fadeIn" onClick={e => e.stopPropagation()}>
      <div className="md:w-2/5 relative">
        <img src={user.photo} className="w-full h-full object-cover min-h-[400px]" alt={user.name} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-10 md:hidden">
           <h2 className="text-4xl font-black text-white uppercase tracking-tighter">{user.name}</h2>
        </div>
      </div>

      <div className="md:w-3/5 p-12 md:p-16 flex flex-col">
        <div className="flex justify-between items-start mb-10">
          <div className="hidden md:block">
             <h2 className="text-5xl font-black text-gray-900 uppercase tracking-tighter leading-none mb-2">{user.name}</h2>
             <p className="text-red-600 font-black uppercase text-[10px] tracking-widest">{user.city} • {user.activitySphere}</p>
          </div>
          <button onClick={onClose} className="bg-gray-100 p-3 rounded-full hover:bg-red-50 text-gray-400 hover:text-red-600 transition-all">✕</button>
        </div>

        <div className="space-y-10 flex-1">
          <section>
             <h4 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-3">О себе</h4>
             <p className="text-sm text-gray-600 italic leading-relaxed">"{user.aboutMe}"</p>
          </section>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <section>
               <h4 className="text-[10px] font-black text-green-600 uppercase tracking-widest mb-3">Чем полезен</h4>
               <p className="text-sm font-bold text-gray-900 leading-relaxed">{user.canHelpWith || '—'}</p>
            </section>
            <section>
               <h4 className="text-[10px] font-black text-red-600 uppercase tracking-widest mb-3">Что ищу</h4>
               <p className="text-sm font-bold text-gray-900 leading-relaxed">{user.lookingFor || '—'}</p>
            </section>
          </div>
          
          <div className="flex gap-4 border-t pt-10">
            <button onClick={() => { onInvite(user); onClose(); }} className="flex-1 py-6 bg-black text-white font-black rounded-2xl uppercase tracking-widest text-xs hover:bg-red-600 transition-all shadow-xl">Предложить встречу ☕️</button>
            <a href={`https://t.me/${user.tgHandle.replace('@', '')}`} target="_blank" className="px-8 py-6 border-2 border-gray-900 text-gray-900 font-black rounded-2xl uppercase tracking-widest text-xs flex items-center justify-center">Telegram</a>
          </div>
        </div>
      </div>
    </div>
  );
};
